export default "__VITE_ASSET__BjQy021v__"